export default __webpack_public_path__ + "static/bg-0e6a8993dca498e5124ba38e1bfe5ac2.png";